import React from "react";
import { useParams } from "react-router-dom";
import { List } from "components";
import { EvtHeader, EvtSectionHeader } from "components/header";
import HeaderPortal from "components/portal/header-portal";
import { EvtStatsCard } from "components/stats/display-card";
import { PermissionControlledInput } from "permissions/components/input";
import CreateItemButton from "components/buttons/create";
import { useJob } from "@/modules/work/jobs/context";
import { usePermissions } from "contexts/permission";
import AllocationTotalBanner from "./total-banner";
import { sumPercentages } from "./sum-percentages";

export default function JobAllocation() {
  const { config, job } = useJob();
  const { jobId } = useParams();
  const { type } = useJob();

  const permissions = usePermissions();

  const [percentTotal, setPercentTotal] = React.useState(null);
  const isPercentType = ["hourly", "bucket"].includes(type);
  // onResponseChange fires on every fetch (including empty results), so the
  // total resets to 0 when there are no rows instead of staying stale.
  const handleResponseChange = React.useCallback(
    (response) => setPercentTotal(sumPercentages(response?.items)),
    []
  );

  const canReadBudgetMargin =
    permissions.hasFieldAccess(`${type}_job_config`, "read", "budget_margin") ||
    permissions.hasFieldAccess("billables", "read", "amount");

  const fields = [
    "id",
    "department.name",
    "grade.name",
    "percentage",
    "hours",
    "job.id",
    "job.name",
  ];

  const hourlycolumns = [
    {
      id: "department.name",
      header: "Department",
      accessorKey: "department.name",
    },
    {
      id: "grade.name",
      header: "Grade",
      accessorKey: "grade.name",
    },
    {
      id: "percentage",
      header: "Percentage (%)",
      accessorKey: "percentage",
      sortable: true,
    },
  ];

  const columns = [
    {
      id: "department.name",
      header: "Department",
      accessorKey: "department.name",
    },
    {
      id: "grade.name",
      header: "Grade",
      accessorKey: "grade.name",
    },
    {
      id: "hours",
      header: "Hours",
      accessorKey: "hours",
      sortable: true,
    },
  ];

  const filters = {
    job: {
      id: jobId,
    },
  };

  const createBudget =type !== "free";

  return (
    <div className="flex-1">
      {isPercentType && percentTotal !== null && percentTotal < 100 && (
        <div className="px-4 md:px-6 pt-4">
          <AllocationTotalBanner type={type} total={percentTotal} />
        </div>
      )}
      {canReadBudgetMargin && (
        <section>
          <EvtHeader title="Allocation" />
          <div className="grid grid-cols-3 px-4 pb-4 gap-4 md:px-6 min-h-24">
            <EvtStatsCard
              label="Budget Margin (%)"
              value={config?.budget_margin || "N/A"}
            />
          </div>
        </section>
      )}
      {createBudget && (
        <HeaderPortal className="order-1">
          <PermissionControlledInput
            rule="create:PC,SC,AM"
            collection="allocated_hours"
            showWhenDisabled={false}
          >
            <CreateItemButton href>Allocation</CreateItemButton>
          </PermissionControlledInput>
        </HeaderPortal>
      )}
      
      <List
        // title={"Allocation"}
        storageKey={`allocation-${jobId}`}
        endPoint="allocated_hours"
        filters={filters}
        columns={isPercentType ? hourlycolumns : columns}
        rowClassName="h-10"
        showSearch={false}
        meta={{ fields }}
        paginate={false}
        onResponseChange={handleResponseChange}
      />
    </div>
  );
}
